export default __webpack_public_path__ + "img/esZVSANG.d9109acd.svg";